export const initImageSizeSetting = (column) => {
    let setting = column.getElement().querySelector('.ac-column-setting--image');
    if (setting) {
        new ImageSizeSetting(column, setting);
    }
};
export class ImageSizeSetting {
    constructor(column, setting) {
        this.column = column;
        this.setting = setting;
        this.field = this.setting.querySelector('.ac-setting-input select');
        this.initState();
        this.bindEvents();
    }
    getValue() {
        return this.field.value;
    }
    bindEvents() {
        this.field.addEventListener('change', () => this.initState());
    }
    initState() {
        this.toggleSubSettings('cpac-custom' === this.getValue());
    }
    toggleSubSettings(show = true) {
        this.setting.querySelectorAll('.ac-column-setting').forEach(setting => setting.style.display = show ? 'table' : 'none');
    }
}
